import {
  brandThemeKey,
  brandThemes,
  DEFAULT_BRAND_THEME,
} from '~/themes/brandThemes';

export function useBrandTheme() {
  const name = inject(
    brandThemeKey,
    computed(() => DEFAULT_BRAND_THEME)
  );
  const theme = computed(() => brandThemes[name.value]);
  return { name, theme };
}
